export const SET_USER_FILTER = 'SET_USER_FILTER'
export const SET_SELECTED_FILTER = 'SET_SELECTED_FILTER'
export const SET_SUB_FILTER = 'SET_SUB_FILTER'
export const SET_ACTIVE_USER_FILTER = 'SET_ACTIVE_USER_FILTER'
export const RESET_FILTERS = 'RESET_FILTERS'
